import React from 'react';

import DataGrid from './DataGrid';
import { DataGridColDef } from './DataGrid/DataGrid';
import { PropElemScheduleResponse } from '../services/proposal';
import { toCurrency } from '../utils/utils';
import AccountingEntryModal from '../pages/Accounting/Components/AccountingEntryModal';

const COLUMNS: DataGridColDef<PropElemScheduleResponse>[] = [
  {
    comcode: 'SpreadingSchedule.ctsorder',
    dataIndex: 'ctsorder',
    fixed: 'left',
    width: 80,
  },
  {
    comcode: 'SpreadingSchedule.ctstype',
    dataIndex: 'ctstype',
    fixed: 'left',
    width: 100,
  },
  {
    comcode: 'SpreadingSchedule.ctscategory',
    dataIndex: 'ctscategory',
    fixed: 'left',
    width: 100,
  },
  {
    comcode: 'SpreadingSchedule.ctsduedate',
    dataIndex: 'ctsduedate',
    fixed: 'left',
    width: 100,
  },
  {
    align: 'right',
    comcode: 'SpreadingSchedule.ctsstartamount',
    dataIndex: 'ctsstartamount',
    render: toCurrency,
    width: 100,
  },
  {
    align: 'right',
    comcode: 'SpreadingSchedule.ctsamortizedamount',
    dataIndex: 'ctsamortizedamount',
    render: toCurrency,
    width: 100,
  },
  {
    align: 'right',
    comcode: 'SpreadingSchedule.ctsoutstandingamount',
    dataIndex: 'ctsoutstandingamount',
    render: toCurrency,
    width: 100,
  },
  {
    comcode: 'SpreadingSchedule.ctsstartdate',
    dataIndex: 'ctsstartdate',
    width: 100,
  },
  {
    comcode: 'SpreadingSchedule.ctsenddate',
    dataIndex: 'ctsenddate',
    width: 100,
  },
  {
    comcode: 'SpreadingSchedule.ctsstatus',
    dataIndex: 'ctsstatus',
    width: 100,
  },
  {
    comcode: 'SpreadingSchedule.accountingdate',
    dataIndex: 'accountingdate',
    width: 100,
  },
  {
    comcode: 'SpreadingSchedule.accountingreference',
    dataIndex: 'accountingreference',
    render: (accountingreference) => (
      <AccountingEntryModal accountingReference={accountingreference} />
    ),
    width: 200,
    fixed: 'right',
  },
];

export type SpreadingScheduleTableProps = {
  financialSchedule: PropElemScheduleResponse[];
};

const SpreadingScheduleTable = (props: SpreadingScheduleTableProps) => {
  const { financialSchedule } = props;

  return (
    <DataGrid
      dataSource={financialSchedule}
      columns={COLUMNS}
      rowKey={(record) => record.ctsorder}
      scroll={{ x: 1000, y: 360 }}
      pagination={{ pageSize: 200 }}
    />
  );
};

export default SpreadingScheduleTable;
